export default function ({app, redirect}) {
  if(!app.$hasPermission('settings')) {
    return redirect(302, '/dashboard');
  }
}